module.exports = __webpack_public_path__ + "img/qz.11ff763f.jpg";